import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FormGroup, NgForm } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { UploadPhotoService } from "../../../../shared/services/upload-photo.service";
import { FileSystemFileEntry, UploadEvent } from "ngx-file-drop";
import * as EXIF from "../../../../shared/modified_modules/exif-js";
import { CategoryService } from "../../../category/services/category.service";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { CamerallaAuthService } from "../../../../shared/services/authentication-services/cameralla-auth.service";
import { Photo } from "../../../../shared/models/cameralla-photo.model";
import * as $ from "jquery";
import { Observable } from "rxjs";
import { of } from "rxjs";
import { GlobalVariables } from "../../../../shared/models/cameralla-global.model";
import { CamerallaUser } from "../../../../shared/models/cameralla-user.model";
import { UserService } from "../../../user/services/user.service";
import { TagInputComponent } from "ngx-chips";
import Swal from "sweetalert2";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MapPopupComponent } from "../map-popup/map-popup.component";
import { GeoLocationService } from "../../../../shared/services/geo-location.service";
import AppShareHelper from "../../../../shared/utils/helper";
import { PermissionAdminService } from "../../../../shared/services/guard-services/permission-admin.service";
import { LocationService } from "../../../../shared/services/location.service";
import * as L from "leaflet";
import { GroupService } from "../../../user/services/group.service";
import * as _ from "underscore";
import {
  GroupLevel,
  SubType,
} from "../../../../shared/constants/group-constant";
import { PhotoService } from "../../../photo/services/photo.service";
import { UploadService } from "../../../../shared/services/upload.service";

@Component({
  selector: "app-photo-upload",
  templateUrl: "./upload.component.html",
  providers: [GeoLocationService],
})
export class UploadComponent implements OnInit {
  @ViewChild("inputTag")
  inputTag: TagInputComponent;

  static readonly maxWidthMobile = 991;
  static readonly maxFileSize = 50000000;
  readonly maxImagesUploadPerDay = 3;

  currentPartner = GlobalVariables.CURRENT_PARTNER;
  newPhoto: Photo;
  fileList: FileList;
  defaultUploadToGlobalGroupId = 41;
  isApplyForLocation = false;
  file: File;
  fileRelated: File;
  formData: FormData;
  formDataRelated: FormData;
  items = [];
  localUserId;
  categories: any[];
  formValid = true;
  photoSelected = true;
  showApplyForLocation = false;
  isUploadToGlobal = false;
  form = new FormGroup({});
  tagMo: string[] = [];
  maxLength = 1000;
  userProfile: CamerallaUser;
  uploading = false;
  isChecked = false;
  defaultTag;
  loaded = false;
  groupList = [];
  currentGroup: any = {};
  wasRelated = "";
  backToFeedLink =
    "/" +
    this.currentPartner.value +
    "/" +
    (this.currentPartner.id == 1 ? "" : this.currentPartner.id);

  lat;
  lng;

  fields: FormlyFieldConfig[] = [
    {
      key: "location",
      type: "autocomplete",
      templateOptions: {
        type: "text",
        placeholder: "Select location",
        required: false,
        change: (field, event) => {
          this.newPhoto.location = field.model.location.display_name
            ? field.model.location.display_name
            : field.model.location;
          this.lat = field.model.location.lat;
          this.lng = field.model.location.lng;
        },
        autoOptions: {
          openMap: (event) => {
            if (event) {
              this.openMap();
            }
          },
          selectItem: (event, model) => {
            this.newPhoto.location = event.item.display_name;
            if (event && event.item) {
              this.lat = event.item.lat;
              this.lng = event.item.lon;
            }
          },
          inputFormatter: (x) => {
            return typeof x === "object" ? x["display_name"] : x;
          },
          resultFormatter: (x) => {
            return x["display_name"];
          },
          remoteData: (term) => {
            return this.geoLocationService.getAddress(term);
          },
        },
      },
    },
  ];

  homeRoute = GlobalVariables.HOME_ROUTE;
  partnerObjects = GlobalVariables.partnerObjects;
  partnerNavigators = GlobalVariables.partnerNavigators;
  sourceObjects = GlobalVariables.sourceObjects;
  sourceNavigators = GlobalVariables.sourceNavigators;
  isAdmin = false;

  originalHeight = 0;
  originalWidth = 0;
  countPhotos = 0;
  constructor(
    private router: Router,
    private toastr: ToastrService,
    private uploadService: UploadService,
    private uploadPhotoService: UploadPhotoService,
    protected route: ActivatedRoute,
    private locationService: LocationService,
    private groupService: GroupService,
    private categoryService: CategoryService,
    private authService: CamerallaAuthService,
    private modalService: NgbModal,
    private geoLocationService: GeoLocationService,
    private userService: UserService,
    private photoService: PhotoService
  ) {
    this.newPhoto = new Photo();
    this.localUserId = +this.authService.getLocalUserInfo()["id"];
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const element = document.querySelector("main section.wrapper");
      element.classList.add("custom-wrapper");
    }, 500);

    $("tag-input-form").append(
      ' <button (click)="addTag()" id="button-add-tag" class="btn btn-tag btn-primary text-white">Add</button>'
    );

    $("#button-add-tag").click(() => {
      if (this.inputTag.inputTextValue) {
        this.inputTag.items.push(this.inputTag.inputTextValue);
        this.inputTag.inputTextValue = "";
      }
    });
  }

  ngOnInit() {
    this.getDefautTag();
    this.newPhoto.partner = this.partnerObjects.GLOBAL;
    this.newPhoto.source = this.checkSizeWindowMobile()
      ? this.sourceObjects.MOBILE
      : this.sourceObjects.DEFAULT;

    this.userService
      .getUserInformation(this.localUserId)
      .then((resolve: any[]) => {
        this.isAdmin = resolve[0].role == PermissionAdminService.adminConst;
        this.userProfile = Object.assign(resolve[0], resolve[1]);
        if (
          this.userProfile.kartraTagIds &&
          this.userProfile.kartraTagIds.includes(
            this.partnerObjects.HURTIGRUTEN.id
          )
        ) {
          this.newPhoto.partner = this.partnerObjects.HURTIGRUTEN;
        }
        if (
          this.userProfile.kartraTagIds &&
          this.userProfile.kartraTagIds.includes(
            this.partnerObjects.KAMPSPORT.id
          )
        ) {
          this.newPhoto.partner = this.partnerObjects.KAMPSPORT;
        }
        if (
          this.userProfile.kartraTagIds &&
          this.userProfile.kartraTagIds.includes(this.partnerObjects.NAF.id)
        ) {
          this.newPhoto.partner = this.partnerObjects.NAF;
        }

        const start = AppShareHelper.getDateTimeWithTimezone(
          new Date(),
          "start",
          2
        );
        const end = AppShareHelper.getDateTimeWithTimezone(
          new Date(),
          "end",
          2
        );
        this.photoService
          .countPhotos({
            customerId: this.localUserId,
            create_at: {
              between: [start.toISOString(), end.toISOString()],
            },
            groupId: null,
            wasRelated: null,
          })
          .toPromise()
          .then((data: any) => {
            if (data.Data && data.Data.count >= this.maxImagesUploadPerDay) {
              this.countPhotos = data.Data.count;
              if (!this.route.snapshot.queryParamMap.get("groupId")) {
                Swal.fire({
                  title: "You’ve reached your daily limit!",
                  html: `
                                    <p>You've shared 3 fantastic photos today. We’d love to see more from you, come back tomorrow to share more of your favorites! </p>
                                    <br>
                                    <p>In the meantime, why not check out others’ photos? Engage with the community and leave some positive feedback.</p>
                                    <p>Remember, the more feedback you give, the more you’ll get back on your own posts!</p>`,
                  showCancelButton: false,
                  confirmButtonText: "Ok",
                }).then((result) => {
                  if (result.value) {
                    this.router.navigate(["/"]);
                  }
                });
              }
            }
          });

        this.groupService
          .getMyGroups(this.localUserId, "joined")
          .subscribe((groups: any) => {
            if (groups && groups.Data && groups.Data.length) {
              this.groupList = groups.Data.filter(
                (item) =>
                  item.level != GroupLevel.member ||
                  item.group.subType !== SubType.PUBLIC_RESTRICTED
              );
            }

            this.loaded = true;
            if (this.route.snapshot.queryParamMap.get("groupId")) {
              this.currentGroup = _.find(this.groupList, (o) => {
                return (
                  o.group.id == this.route.snapshot.queryParamMap.get("groupId")
                );
              });
              if (this.currentGroup) {
                this.selectGroup(this.currentGroup);
                this.backToFeedLink =
                  "/user/group/" +
                  this.route.snapshot.queryParamMap.get("groupId");
              } else {
                this.router.navigate(["/user/my-groups"]);
              }
            }
          });
      });

    this.categoryService
      .getCategories()
      .toPromise()
      .then(
        (response) => {
          this.categories = response["Data"];
          this.newPhoto.category = this.categories[6];
        },
        (error) => {
          console.log("upload error " + error);
        }
      );
  }

  public fileChange(event) {
    // if (this.form.get('location').value) {
    //     this.form.get('location').setValue(null);
    //     this.lat = this.lng = null;
    // }

    this.fileList = event.target.files;

    if (this.fileList.length > 0) {
      // Update new service
      if (
        this.uploadPhotoService.fileTypes.indexOf(this.fileList[0].type) + 1
      ) {
        this.file = this.fileList[0];
        this.setLocalPreview(this.file);
      } else {
        this.toastr.error("File type not allowed", "Error");
      }
    }
  }

  public onImageLoad(image: HTMLImageElement) {
    this.originalHeight = image.naturalHeight;
    this.originalWidth = image.naturalWidth;
  }

  public upload(f: NgForm) {
    if (this.file && this.file.name) {
      if (f.valid) {
        this.formValid = true;
        this.formData = new FormData();
        // append file to form data
        // this.formData.append("photo", this.file, this.file.name);
        this.formData.append("customerId", this.localUserId);
        this.formData.append(
          "location",
          this.newPhoto.location ? this.newPhoto.location : "Unknown"
        );
        this.formData.append("lat", this.lat);
        this.formData.append("lng", this.lng);
        this.formData.append("traceLog", "1");

        if (this.currentGroup.groupId) {
          this.formData.append("groupId", this.currentGroup.groupId);
        }

        if (this.isUploadToGlobal) {
          this.formData.append("uploadToGlobal", "true");
        }

        if (f.value.tags) {
          f.value.tags = f.value.tags.map((tag) =>
            tag.replace(/[^?!-øæå\w\s]/gi, "")
          );
        }

        // if (this.defaultTag.length) {
        //     f.value.tags.push(...this.defaultTag)
        // }

        // if (this.userProfile && this.userProfile.memberships.length > 0) {
        //     f.value.tags.push(...this.userProfile.memberships);
        // }

        // @ts-ignore
        f.value.tags = _.uniq(f.value.tags);

        if (this.fileRelated && this.fileRelated.name) {
          this.formDataRelated = new FormData();
          this.formDataRelated.set("customerId", this.localUserId);
          this.formDataRelated.set(
            "photo",
            this.fileRelated,
            this.fileRelated.name
          );
          this.formDataRelated.set("title", this.fileRelated.name);
          this.formDataRelated.set("wasRelated", this.wasRelated);
        }

        for (const key in f.value) {
          if (f.value.hasOwnProperty(key)) {
            if (f.value[key] && f.value[key].length > this.maxLength) {
              this.formValid = false;
            } else {
              if (key === "title" && !f.value[key]) {
                this.formData.append(key, "Untitled");
              } else {
                if (!(key === "subCategoryId" && !f.value[key])) {
                  this.formData.append(key, f.value[key]);
                }
              }
            }
          }
        }

        if (this.newPhoto.source !== this.sourceObjects.DEFAULT) {
          if (this.formValid) {
            Swal.fire({
              title: "Confirmation",
              text:
                "This photo was captured by a " +
                this.newPhoto.source.desc +
                "?",
              showCancelButton: true,
              confirmButtonText: "Yes, upload it",
              cancelButtonText: "No, change camera type",
            }).then((result) => {
              if (result.value) {
                let createLocationObs = of({});

                if (this.isApplyForLocation) {
                  //create location
                  if (this.lat && this.lng && this.newPhoto.location) {
                    this.uploading = true;

                    createLocationObs = this.locationService.createLocation({
                      address: f.value.locationName,
                      partnerId: f.value.partnerId,
                      lat: this.lat,
                      lng: this.lng,
                      description: f.value.locationDescription,
                      locationUrl: f.value.locationUrl,
                      subCategoryId: this.newPhoto.category.subId || null,
                      categoryId: this.newPhoto.category.id,
                      groupId: this.currentGroup.groupId,
                    });
                  } else {
                    this.toastr.error(
                      "Please pin the location on the map",
                      "UPLOAD FAILED"
                    );
                    return;
                  }
                }

                createLocationObs.subscribe(
                  (location: any) => {
                    this.uploading = true;
                    if (location.Data && location.Data.id) {
                      this.formData.append("locationId", location.Data.id);
                      this.formData.append("isPrimaryLocation", "true");
                    }
                    this.uploadService
                      .uploadFileToS3("photo", this.file)
                      .toPromise()
                      .then((url) => {
                        this.formData.append("original", url);
                        this.formData.append(
                          "width",
                          this.originalWidth.toString()
                        );
                        this.formData.append(
                          "height",
                          this.originalHeight.toString()
                        );
                        this.uploadPhotoService.upload(
                          this.formData,
                          this.formDataRelated,
                          this.isChecked
                        );
                      });
                  },
                  (error) => {
                    this.toastr.error(
                      "Check your input and try again.",
                      "UPLOAD FAILED"
                    );
                  }
                );
              } else {
                setTimeout(() => {
                  $("#photoSource").addClass("text-danger");
                  $("html, body").animate(
                    {
                      scrollTop: $("#photoSource").offset().top - 100,
                    },
                    "slow"
                  );
                }, 0);
              }
            });
          } else {
            this.toastr.error(
              "Check your input and try again.",
              "UPLOAD FAILED"
            );
            this.failValidation();
          }
        } else {
          this.formValid = false;
          this.failValidation();
        }
      } else {
        this.formValid = false;
        this.failValidation();
      }
    } else {
      this.photoSelected = false;
      this.formValid = false;
      this.topFunction();
    }
  }

  public dropped(event: UploadEvent) {
    if (event.files) {
      const droppedFile = event.files[0];

      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;

        fileEntry.file((file: File) => {
          // Update new service
          if (this.uploadPhotoService.fileTypes.indexOf(file.type) + 1) {
            this.file = file;
            this.setLocalPreview(this.file);
          } else {
            this.toastr.error("Files not allowed", "Error");
          }
        });
      } else {
        this.toastr.error("Only one file can be dropped", "Error");
      }
    }
  }

  public getDefautTag() {
    const date = new Date();
    this.defaultTag = [];
    this.defaultTag.push(
      "#" +
        date.toLocaleString("default", { month: "long" }).toLowerCase() +
        date.getFullYear()
    );
    this.defaultTag.push(
      "#" +
        date.toLocaleString("en", { month: "long" }).toLowerCase() +
        date.getFullYear()
    );
    // @ts-ignore
    this.defaultTag = _.uniq(this.defaultTag);
  }

  public setLocalPreview(file: File) {
    this.photoSelected = true;
    const me = this;
    const mobileList = GlobalVariables.mobile_device_list;
    const defaultModel = {
      model: "Canon EOS 1D X Mark II",
      lens: "50mm f1.8",
      aperture: "2.2",
      ISO: "300",
      shutterSpeed: "1/1600",
      focalLength: "24",
    };

    if (file.size < UploadComponent.maxFileSize) {
      EXIF.getData(file, function () {
        const allMetaData = EXIF.getAllTags(this);

        // me.handleLocation(allMetaData);

        if (allMetaData) {
          me.newPhoto.model = allMetaData.Model || defaultModel.model;
          me.newPhoto.lens = allMetaData.FocalLength
            ? me.uploadPhotoService.roundExif(
                allMetaData.FocalLength.numerator,
                allMetaData.FocalLength.denominator
              ) + "mm "
            : "";
          me.newPhoto.lens += allMetaData.FNumber
            ? "f/" +
              me.uploadPhotoService.roundExif(
                allMetaData.FNumber.numerator,
                allMetaData.FNumber.denominator
              )
            : defaultModel.lens;
          me.newPhoto.aperture = allMetaData.FNumber
            ? me.uploadPhotoService.roundExif(
                allMetaData.FNumber.numerator,
                allMetaData.FNumber.denominator
              )
            : defaultModel.aperture;
          me.newPhoto.ISO = allMetaData.ISOSpeedRatings || defaultModel.ISO;
          me.newPhoto.shutterSpeed = allMetaData.ExposureTime
            ? allMetaData.ExposureTime.numerator +
              "/" +
              allMetaData.ExposureTime.denominator
            : defaultModel.shutterSpeed;
          me.newPhoto.focalLength = allMetaData.FocalLength
            ? me.uploadPhotoService.roundExif(
                allMetaData.FocalLength.numerator,
                allMetaData.FocalLength.denominator
              )
            : defaultModel.focalLength;
          me.newPhoto.source =
            screen.width <= UploadComponent.maxWidthMobile
              ? me.sourceObjects.MOBILE
              : me.sourceObjects.DEFAULT;
          mobileList.forEach((device) => {
            if (me.newPhoto.model.toLowerCase().includes(device)) {
              me.newPhoto.source = me.sourceObjects.MOBILE;
            }
          });
          if (me.newPhoto.source !== me.sourceObjects.MOBILE) {
            me.newPhoto.source = me.sourceObjects.SYSTEM;
          }
        }
      });

      const reader = new FileReader();
      const image = new Image();

      reader.readAsDataURL(file);

      reader.onload = (e: any) => {
        image.src = this.newPhoto.localURL = reader.result;

        image.onload = (rs) => {
          if (rs.currentTarget["width"] && rs.currentTarget["height"]) {
            //Default Width: 800
            this.newPhoto.width = 800;
            this.newPhoto.height = AppShareHelper.resize(
              rs.currentTarget["width"],
              rs.currentTarget["height"]
            );
          }
        };
      };
    } else {
      this.toastr.error("Max file size exceeds 50MB", "Error");
    }
  }

  public fileOver(event) {}

  public fileLeave(event) {}

  selectCategory(category, subCategory?) {
    this.newPhoto.category = category;

    this.showApplyForLocation = category.categoryType === "location";
    this.isApplyForLocation = false;

    if (subCategory) {
      this.newPhoto.category.subId = subCategory.id;
      this.newPhoto.category.subName = subCategory.name;
    } else {
      this.newPhoto.category.subId = null;
      this.newPhoto.category.subName = null;
    }
  }

  selectPartner(partner) {
    this.currentGroup = {};
    this.newPhoto.partner = partner;
    this.isUploadToGlobal = false;

    if (partner.id === 2 && !this.checkSizeWindowMobile()) {
      this.selectSource(this.sourceObjects.SYSTEM);
    }

    if (partner.id == 99) {
      this.selectCategory({
        name: "Landscape",
        type: null,
        categoryType: "location",
        id: 1,
      });
      this.isApplyForLocation = true;
    }
  }

  selectGroup(group) {
    this.isUploadToGlobal = false;
    this.currentGroup = group;
    this.newPhoto.partner = {
      name: group.group.name,
      id: group.group.partnerId,
    };

    if (group.group.id == this.defaultUploadToGlobalGroupId) {
      this.isUploadToGlobal = true;
    }
  }

  selectSource(source) {
    $("#photoSource").removeClass("text-danger");
    this.newPhoto.source = source;
  }

  topFunction() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
  }

  failValidation() {
    setTimeout(() => {
      const offset_top =
        $(".text-danger").offset().top -
        $("main").offset().top +
        $("main").scrollTop() -
        50;
      $("html, body").animate({ scrollTop: offset_top }, "slow");
    }, 0);
  }

  public onAdding(tag: string): Observable<any> {
    return of(tag.toLocaleLowerCase());
  }

  public checkSizeWindowMobile() {
    return screen.width <= UploadComponent.maxWidthMobile;
  }

  handleLocation(data) {
    if (!(data.GPSLatitude && data.GPSLongitude)) return; // whoops, no GPS info

    // convert from deg/min/sec to decimal for Google
    const strLatRef = data.GPSLatitudeRef || "N";
    const strLongRef = data.GPSLongitudeRef || "W";

    this.lat =
      (data.GPSLatitude[0] +
        data.GPSLatitude[1] / 60 +
        data.GPSLatitude[2] / 3600) *
      (strLatRef == "N" ? 1 : -1);
    this.lng =
      (data.GPSLongitude[0] +
        data.GPSLongitude[1] / 60 +
        data.GPSLongitude[2] / 3600) *
      (strLongRef == "W" ? -1 : 1);

    if (this.lat && this.lng) {
      this.geoLocationService
        .getReverseGeo(this.lat, this.lng)
        .subscribe((res) => {
          if (res && res["display_name"]) {
            this.form.get("location").setValue(res["display_name"]);
            this.newPhoto.location = res["display_name"];
          }
        });
    }
  }

  openMap() {
    const modalRef = this.modalService.open(MapPopupComponent, {
      backdrop: "static",
      windowClass: "map-modal",
    });
    modalRef.componentInstance.lat = this.lat;
    modalRef.componentInstance.lng = this.lng;
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      if (receivedEntry.address) {
        //this.form.get('location').setValue(receivedEntry.address);
        //this.newPhoto.location = receivedEntry.address;
        this.lat = receivedEntry.lat;
        this.lng = receivedEntry.lng;
        this.initMap(this.lat, this.lng);
      }
    });
  }

  getPhotoRelated(file) {
    this.fileRelated = file;
    if (file.wasRelated) {
      this.wasRelated = file.wasRelated;
    }
  }

  ngOnDestroy() {
    const element = document.querySelector("main section.wrapper");
    element.classList.remove("custom-wrapper");
  }

  public map;

  public initMap(lat, lng, zoom = 16) {
    // refresh map id
    document.getElementById(
      "map-preview"
    ).innerHTML = `<div id='map-content-preview' style='width: 100%; height: 100%;'></div>`;

    this.map = L.map("map-content-preview", {
      center: [lat, lng],
      // Set the initial zoom level, values 0-18, where 0 is most zoomed-out (required)
      zoom: zoom,
      preferCanvas: true,
    });

    L.tileLayer("http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}", {
      maxZoom: 20,
      subdomains: ["mt0", "mt1", "mt2", "mt3"],
    }).addTo(this.map);

    L.marker([lat, lng], {
      icon: L.icon({
        iconUrl: "./assets/images/location-pin.png",
        iconSize: [40, 40], // size of the icon
        popupAnchor: [0, -15], // point from which the popup should open relative to the iconAnchor
      }),
    }).addTo(this.map);

    //handle click event
    this.map.on("click", (e) => {
      this.openMap();
    });
  }
}
